import { ActionType, EVENT_ENABLED_MODIFY_MESSAGE } from "constant";
import ActuatorAction from "pages/events/components/actions/ActuatorAction";
import NotificationAction from "pages/events/components/actions/NotificationAction";
import DelayAction from "pages/events/components/actions/DelayAction";
import VariableAction from "pages/events/components/actions/VariableAction";
import { MouseEvent } from "react";
import { showErrorAlert } from "utils/alert";

type ActionItemProps = {
    eventId: string;
    actionId: string;
    showDeleteConfirm: any;
    actuatorName: string;
    actuatorType: string;
    actuatorMode: string;
    actuatorControl: string;
    action: any;
    eventActive: boolean;
    editDelayAction: () => void;
    eventVariableAction: any;
};

const ActionItem = (props: ActionItemProps) => {
    const checkEditable = (
        e?: MouseEvent<
            HTMLAnchorElement | HTMLButtonElement,
            globalThis.MouseEvent
        >
    ) => {
        if (props.eventActive) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            showErrorAlert({
                message: EVENT_ENABLED_MODIFY_MESSAGE,
            });
            return false;
        }

        return true;
    };

    const renderActionItem = () => {
        switch (props.action.type_) {
            case ActionType.ACTUATOR:
                return (
                    <ActuatorAction {...props} checkEditable={checkEditable} />
                );
            case ActionType.EMAIL:
            case ActionType.PUSH:
            case ActionType.SMS:
                return (
                    <NotificationAction
                        {...props}
                        actionType={props.action.type_}
                        checkEditable={checkEditable}
                    />
                );
            case ActionType.DELAY:
                return (
                    <DelayAction
                        {...props}
                        editDelayAction={props.editDelayAction}
                        checkEditable={checkEditable}
                    />
                );
            case ActionType.VARIABLE:
                return (
                    <VariableAction
                        {...props}
                        eventVariableAction={props.eventVariableAction}
                        checkEditable={checkEditable}
                    />
                );
            default:
                return <></>;
        }
    };

    return <>{renderActionItem()}</>;
};

export default ActionItem;
